import { render, staticRenderFns } from "./NotaPostOperatoria.vue?vue&type=template&id=28324a82&scoped=true&"
import script from "./NotaPostOperatoria.vue?vue&type=script&lang=js&"
export * from "./NotaPostOperatoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28324a82",
  null
  
)

export default component.exports